module.exports = __webpack_public_path__ + "img/index-shareWx.ea753a92.png";